import { render, staticRenderFns } from "./ClientSelectorModal.vue?vue&type=template&id=60f8c674&scoped=true&"
import script from "./ClientSelectorModal.vue?vue&type=script&lang=js&"
export * from "./ClientSelectorModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f8c674",
  null
  
)

export default component.exports